var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.323,
    height: 21.323,
    viewBox: "0 0 21.323 21.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgd2lkdGg9IjE0Ij48cGF0aCBkPSJNMC4yNSAwLjI1VjEzLjc1SDEzLjc1VjAuMjVIOS44MTI1VjEuMzc1SDEyLjYyNVY3LjU2MjVIMTEuNVY4LjY4N",
    d: "M.25.25v21.323h21.323V.25h-6.219v1.777H19.8V11.8h-1.78v1.777h1.78V19.8h-8v-6.223h1.777V11.8H8.246v1.777h1.777V19.8h-8v-6.223H3.8V11.8H2.027V2.027h5.942l5.109 3.415 1-1.5L8.746.389 8.524.25z",
    transform: "translate(-.25 -.25)",
    style: {
      fill: "#6f6e6e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomIcon);
export default __webpack_public_path__ + "static/media/room_icon.b20bc89888fa1929b95de696cf4e7a8f.svg";
export { ForwardRef as ReactComponent };